export class documentHelper {
    static formatCNPJ(value: string): string {
        const numbers = value.replace(/\D/g, "").slice(0, 14);
        return numbers
            .replace(/^(\d{2})(\d)/, "$1.$2")
            .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
            .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3/$4")
            .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d)/, "$1.$2.$3/$4-$5");
    }
    static cleanDocument(document: string): string {
        return document.replace(/[.\-\/]/g, "");
    }

    static formatCPF(value: string): string {
        const numbers = value.replace(/\D/g, "");
        return numbers
            .replace(/^(\d{3})(\d)/, "$1.$2")
            .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
            .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4")
            .slice(0, 14);
    }

    static onlyNumbers(value: string): string {
        return value.replace(/\D/g, "");
    }
}